import React from 'react';
import { useSelector } from 'react-redux';
import {
    Button,
    TextField,
} from '@mui/material';
import { Form, Label } from 'reactstrap';
import { formatMoneyDisplayValue } from '../../utils/moneyFormat';
import { useAdminCompany } from '../../context/AdminCompanyContext';
import { useUpdateCompany } from '../../hooks/useCompanies';

function CompanyRate(){
    const { companyData } = useAdminCompany();
    const [rate, setRate] = React.useState(() => formatMoneyDisplayValue(companyData?.companyRate));
    const updateCompany = useUpdateCompany();
    const userId = useSelector((state) => state.UserReducer.isAuthenticated?.id);

    React.useEffect(() => {
        setRate(formatMoneyDisplayValue(companyData?.companyRate));
    }, [companyData?.id]);

    let company = {
        Id: companyData?.id,
        Name: companyData?.name,
        City: companyData?.city,
        Country: companyData?.country,
        State: companyData?.state,
        Street: companyData?.street,
        Zip: companyData?.zip,
        ProcessExternal: companyData?.processExternal,
        Email: companyData?.email,
        PhoneNumber: companyData?.phoneNumber,
        CompanyStatus: companyData?.companyStatus,
        AccountingEmail: companyData?.accountingEmail,
        CompanyRate: rate
    };

    async function onSubmit(){
        const formattedRate = formatMoneyDisplayValue(rate);
        setRate(formattedRate);
        await updateCompany.mutateAsync({
            company: { ...company, CompanyRate: formattedRate },
            userId,
        });
    };

    return(
        <Form>
            <div style={{display:'flex', marginTop:'10px'}}>
                <Label style={{margin:'auto', marginRight:'10px', width:'20%'}}><b>Company Rate:</b></Label>
                <TextField
                    fullWidth
                    onChange={(event)=>setRate(event.target.value)}
                    onBlur={() => setRate(formatMoneyDisplayValue(rate))}
                    value={rate ?? ''}
                    inputProps={{ inputMode: 'decimal', 'aria-label': 'Company Rate' }}
                />
            </div>
            <Button variant="contained"
                fullWidth sx={{ marginTop: '5px', height: '3.4375em', padding: '16.5px 14px', width:'82%', marginLeft:'18%' }}
                color="primary"
                onClick={()=>onSubmit()}
                >
                Update Company Rate
            </Button>
        </Form>
    )
}

export default CompanyRate;
